import { Switch, message } from 'antd';
import type { SecurityRequestStatus } from '@wisecure/api-client';
import { StatusBadge } from '@/components/base';
import { REQUEST_STATUS_LABELS } from './labels';
import { useSecurityRequestUpdate } from './useSecurityRequestUpdate';

export function SecurityRequestStatusTag({ status }: { status: SecurityRequestStatus }) {
  return (
    <StatusBadge
      status={status === 'HANDLED' ? 'VALIDATED' : 'PENDING'}
      label={REQUEST_STATUS_LABELS[status]}
    />
  );
}

interface SecurityRequestStatusSwitchProps {
  id: string;
  status: SecurityRequestStatus;
  size?: 'small' | 'default';
}

/** Toggles a request between "Traitée" and "Non traitée". Clicks don't bubble to the table row. */
export function SecurityRequestStatusSwitch({ id, status, size = 'default' }: SecurityRequestStatusSwitchProps) {
  const update = useSecurityRequestUpdate();

  const handleChange = (handled: boolean) => {
    update.mutate(
      { id, body: { status: handled ? 'HANDLED' : 'PENDING' } },
      {
        onSuccess: () =>
          message.success(handled ? 'Demande marquée comme traitée' : 'Demande marquée comme non traitée'),
        onError: () => message.error('Impossible de mettre à jour la demande'),
      },
    );
  };

  return (
    <span onClick={(e) => e.stopPropagation()}>
      <Switch
        size={size}
        checked={status === 'HANDLED'}
        loading={update.isPending}
        checkedChildren="Traitée"
        unCheckedChildren="Non traitée"
        onChange={handleChange}
      />
    </span>
  );
}
